import { render, staticRenderFns } from "./EmergencyLoginForm.vue?vue&type=template&id=effc68d4&"
import script from "./EmergencyLoginForm.vue?vue&type=script&lang=js&"
export * from "./EmergencyLoginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports